import type {QueryClient} from "@tanstack/react-query";
import {z as zod} from "zod";
import {adminWorkspaceValidator, type AdminWorkspace} from "~/domainModels/adminModels/adminWorkspaces";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {uniqueUuid} from "@vesta/unique/unique";

export const WORKSPACES_QUERY_KEY = uniqueUuid`d5e3f4a6-9b0c-4d1e-b3f4-a5b6c7d8e9f0`;

export async function getAdminWorkspacesWithCaching({
    queryClient,
    intellsysBaseUrl,
    accessToken,
}: {
    queryClient: QueryClient;
    intellsysBaseUrl: string;
    accessToken: string;
}): Promise<Array<AdminWorkspace>> {
    return queryClient.ensureQueryData<Array<AdminWorkspace>>({
        queryKey: [WORKSPACES_QUERY_KEY],
        queryFn: async () => {
            const result = await robustJsonResultClientFetch(
                `${intellsysBaseUrl}/sub-system/pluto/admin/workspaces/get`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessToken}`,
                    },
                    body: JSON.stringify({limit: 1000, offset: 0}),
                },
                zod.array(adminWorkspaceValidator),
            );
            if (result.success !== true) {
                throw new Error("Failed to fetch workspaces");
            }
            return result.data;
        },
    });
}
